/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenancemessage1Inputs */



/**
* | output |
* | --- |
* | "Maintenance" |
*
* @param {Maintenancemessage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maintenancemessage1 = /** @type {((inputs?: Maintenancemessage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenancemessage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maintenance")
	return /** @type {LocalizedString} */ ("Wartungsarbeiten")
});
export { maintenancemessage1 as "maintenanceMessage" }